export type AspectRatio = (typeof ASPECT_RATIO)[keyof typeof ASPECT_RATIO]
export const ASPECT_RATIO = {
  SQUARE: 1,
  RECTANGLE: 1.5,
} as const

// Quality warning logic
export const MAX_SQUARE_SIZE = 356
export const MAX_RECTANGLE_WIDTH = 737
export const MAX_RECTANGLE_HEIGHT = 491
